import { render, staticRenderFns } from "./shoukuanlist.vue?vue&type=template&id=3390be3f"
import script from "./shoukuanlist.vue?vue&type=script&lang=js"
export * from "./shoukuanlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports